import React from "react";
import { Link } from "react-router-dom";
import { Route } from "antd/es/breadcrumb/Breadcrumb";

// keep the interface of the arguments
// it is used with the pageheader component from ant
const BreadCrumbsRenderer = (
  route: Route,
  _params: any,
  routes: Array<Route>,
  paths: Array<string>
) => {
  const last = routes.indexOf(route) === routes.length - 1;
  return last ? (
    <span>{route.breadcrumbName}</span>
  ) : (
    <Link to={paths.join("/")}>{route.breadcrumbName}</Link>
  );
};

export default BreadCrumbsRenderer;
